<div class="d-flex align-items-center">
  <a [profile]="user">
    <app-avatar [src]="user.icon" [placeholder]="user | initials" class="medium right"></app-avatar>
  </a>
  <div>
    <div class="name">
      <a [profile]="user">{{ user.name }}</a>
      <svg viewBox="0 0 20 20" *ngIf="user?.is_creditable" class="verify-icon"><use href="#verified" /></svg>
    </div>
    <div class="desc">{{ user.type_name }}</div>
  </div>
</div>
<a
  href=""
  class="link ml-auto"
  *ngIf="!user.is_friend && !user.friend_request"
  (click)="onProfileConnect(user.id); false"
  >Connect +</a
>
<a
  href=""
  class="link ml-auto"
  *ngIf="!user.is_friend && user.friend_request"
  (click)="onProfileUnConnect(user.id); false"
  >Disconnect</a
>
<a href="" class="link ml-auto" *ngIf="user.is_friend" (click)="onProfileRemove(user.id); false">Disconnect</a>
